export default {
  // 5-4
  bbsLoc_list: [],
  bbsHistory_all: [],
  bbsHistory_allList: [],
  bbsHistory_detail: [],
};
